// eslint-disable-next-line import/prefer-default-export
export const removeBrTag = (inputString) => inputString.replace(/<br\s*\/?>/gi, '');
